export default {

    //заполнить данные
    loadOrgs(state, data) {
        state.items = data;
    },

    //обновить
    edit(state, editdata) {
        var ind = state.items.findIndex(x => x.id == editdata.id)
        if (ind != -1 && ind != undefined) {
            state.items.splice(ind, 1, editdata);
        }
    },

    //добавить
    addPartner(state, newdata) {
        state.items.push(newdata)
    },

    //Добавляем нового партнера в сетку
    addPartnerToGrid(state, newData){
        state.partnerGrid.push(newData)
    },

    //удалить
    delete(state, fineId) {
        var ind = state.items.findIndex(x => x.id == fineId)
        if (ind != -1 && ind != undefined) {
            state.items.splice(ind, 1);
        }
    },
    //Удаляем партнера из сетки партнеров в нашем стейте
    deletePartnerFromGrid(state, id){
        const ind = state.partnerGrid.findIndex(x => x.id == id)
        if (ind != -1 && ind != undefined) {
            state.partnerGrid.splice(ind, 1);
        }
    },
    //получить филиалы партнера
    loadBranches(state, data) {
        state.partnerBranches = data
    },

    loadStaff(state,data){
        state.partnerStaff=data
    },

    loadAccessLevels(state, data){
        state.accessLevels=data
    },

    loadStock(state, data){
        state.partnerStocks=data
    },
    loadActivations(state,data){
        state.partnerActivations=data
    },
    loadPartnerGrid(state,data){
        state.partnerGrid=data
    }
}
